const { __, _x, _n, _nx } = wp.i18n;

/**
 * Implements comments folding.
 */
var Folding = ( function() {
	var C = function(){ return constructor.apply(this,arguments); };
	var p = C.prototype;

	function constructor() {
		var self = this;
		var comments = document.getElementById( "comments" );
		if ( ! comments ) {
			return;
		}
		var idCount = 0;
		for ( const children of comments.querySelectorAll( '.depth-1 > .children' ) ) {
			if ( /^#[^ ]+$/.test( window.location.hash )
					 && children.querySelector( window.location.hash ) ) {
				continue;
			}
			children.classList.add( "collapse" );
			var button = document.createElement( "button" );
			button.classList.add( "btn", "btn-light" );
			button.setAttribute( "type", "button" );
			button.addEventListener( 'click', function( event ) {
				event.preventDefault();
				event.target.parentNode.removeChild( event.target );
				jQuery( children ).collapse( 'show' );
			} );
			var numberOfComments = children.querySelectorAll( ".comment" ).length;
			button.innerHTML = _n( "Show one answer", sprintf( "Show %d answers", numberOfComments ), numberOfComments, "iportal-core" );
			children.parentNode.insertBefore( button, children );
		}
	};

	return C;
} )();

export default Folding;